import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../constants/constant'
import createRateTemplate from './../../../../masterdata/views/ratetemplate/createratetemplate'
import MasterService from './../../../../masterdata/services/masterdata.service';
import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
import CustomExpandableTable from '../../../components/customExpandableTable'
import moment from 'moment';
import { Validator } from 'vee-validate';

export default {
  name: 'rates',
  components: {
    VueElementLoading,
    createRateTemplate,
    CustomExpandableTable
  },
  props: ['selectedEdit', 'callingFromClientContract', 'contractidd'],
  data: function() {
    return {
      callingFromClientContractObj: this.callingFromClientContract && JSON.parse(JSON.stringify(this.callingFromClientContract)),
      //selectedEditObj: this.selectedEdit,
      isLoading: false,
      contractServiceId: '',
      Todate: '',
      Fromdate: '',
      selectedEditRow: '',
      callingFromObj: null,
      contractServiceList: [],
      contractRateTemplateDetails: [],
      showRate: false,
      tableColumn: ['Truck Load Type', 'Route Mode', 'Service Type', 'Booking Type', 'Effective Date From', 'Effective Date To', 'Action'],
      tableItems: [],
      innerTableColumn: [],
      tempContractServiceList: [],
      contractRateTemplateDetailsArr: [],
      offset:0,
      servicetype : null
    }
  },
  computed: {

  },
  mounted() {
    this.createTables();
  },
  methods: {
    eventFromChild() {
      console.log("eventFromChild");
    },
    displaybookingType(bookingtype){
      return CONSTANT.BOOKING_MODE[bookingtype];
    },
    async createTables() {
      try {
        this.isLoading = true;
        let hasSeriveIds = []
        let result;
        let payload = {}
        this.tableItems = [];
        this.tempContractServiceList = [];
        this.contractServiceList = []
        if (this.callingFromClientContractObj && this.callingFromClientContractObj.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
          let payload1 = {
            offset: this.offset,
            limit: 999,
            contractid: this.callingFromClientContractObj.id
          }
          let payload2 = {

            contractid: this.callingFromClientContractObj.id
          }
          result = await Promise.all([ClientService.getClientContractMasterServicesDetails(payload1), MasterService.clientContractMasterRateDetails(payload2)])
          this.tempContractServiceList = result[0].data.data.rows;
        } else {
          payload.contractid = this.selectedEdit.id || this.contractidd
          result = await Promise.all([MasterService.getContractMasterServicesDetails(payload), MasterService.contractMasterRateDetails(payload)])
          this.tempContractServiceList = result[0].data.data;
        }
        let effectiveDate = []
        result[1].data.data.rows.forEach((el) => {
          if (el.contractservicesid) {
            hasSeriveIds.push(el.contractservicesid);
            effectiveDate.push({
              serviceId: el.contractservicesid,
              startDate: el.rateeffectivedatefrom,
              endDate: el.rateeffectivedateto
            })
          }
        })
        let tempPreFilledServiceRateList = [];
        this.tempContractServiceList.forEach((el) => {
          if (hasSeriveIds.includes(el.id)) {
            tempPreFilledServiceRateList.push(el);
          } else {
            let tempArr = []
            el.bookingtype.forEach((item) => {
              let type = CONSTANT.BOOKING_MODE[item]
              tempArr.push(type)
            });
            el.bookingtype = tempArr;
            this.contractServiceList.push(el);
          }
        })
        this.tableItems = tempPreFilledServiceRateList.map((el) => {
          let tempArr = []
          el.bookingtype.forEach((item) => {
            let type = CONSTANT.BOOKING_MODE[item]
            tempArr.push(type)
          });
          return {
            'id': el.id,
            'Truck Load Type': el.truckloadtype,
            'Route Mode': el.routemode,
            'Service Type': el.servicetype,
            'Booking Type': tempArr.join(", "),
            'Effective Date From':this.format_date(effectiveDate.find(o => o.serviceId == el.id).startDate),
            'Effective Date To':this.format_date(effectiveDate.find(o => o.serviceId == el.id).endDate),
          }
        })
        this.contractRateTemplateDetailsArr = result[1].data.data.rows;
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        console.log(err)
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('DD-MM-YYYY')
      }
    },
    getCustomTableEvent(event, isCustomChangeDate, dateEvent) {
      if(dateEvent &&  (!this.Fromdate || !this.Todate)){
        this.showRate = false;
        return;
      }
      if (event.actionType == "edit") {
        let selectedServiceEditRow = this.tempContractServiceList.filter(function(Items) {
          return Items.id == event.id;
        });
        this.contractServiceId = selectedServiceEditRow[0].id;
        this.servicetype = selectedServiceEditRow[0].serviceareatype
        let selectedRateTemplateEditRow = this.contractRateTemplateDetailsArr.filter(function(Items) {
          return Items.contractservicesid == event.id;
        });
        this.contractRateTemplateDetails = selectedRateTemplateEditRow[0];
        if(!isCustomChangeDate){
          this.Fromdate = null;
          this.Todate = null;
        }
        this.Fromdate= this.Fromdate || (this.contractRateTemplateDetails && this.contractRateTemplateDetails.rateeffectivedatefrom) || null;
        this.Todate = this.Todate || (this.contractRateTemplateDetails && this.contractRateTemplateDetails.rateeffectivedateto) || null;
        if(this.Fromdate && this.Todate){
          this.$nextTick(() => {
            this.$validator.validateAll().then((result) => {
              if (result) {
                 if (this.callingFromClientContractObj && this.callingFromClientContractObj.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
                   this.clientContractCallingFromObj(this.callingFromClientContractObj.id, this.contractServiceId);
                 } else {
                   this.setContractCallingFromObj()
                 }
               } else{
                 this.showRate = false;
               }
             }).catch(() => {
               console.log('errors exist')
             });
          })
        } else if(!this.Fromdate && !this.Todate) {
          this.$validator.reset();
        }
      }
    },
    clientContractCallingFromObj(contractId, contractservicesid) {
      this.showRate = false;
      this.$nextTick(() => {
        this.callingFromObj = {
          id: (this.contractRateTemplateDetails && this.contractRateTemplateDetails.id) || null,
          name: CONSTANT.CLIENT_CONTRACT_TEMPLATE,
          contractid: contractId,
          contractservicesid: contractservicesid,
          rateeffectivedatefrom: this.Fromdate || (this.contractRateTemplateDetails && this.contractRateTemplateDetails.rateeffectivedatefrom) || null,
          rateeffectivedateto: this.Todate || (this.contractRateTemplateDetails && this.contractRateTemplateDetails.rateeffectivedateto) || null,
          contractRateTemplateDetails: this.contractRateTemplateDetails,
          uom: this.selectedEdit.uom,
          servicetype : this.servicetype
        }
        this.Fromdate = this.callingFromObj.rateeffectivedatefrom;
        this.Todate = this.callingFromObj.rateeffectivedateto;
        this.showRate = true;
        console.log(this.callingFromObj)
      })

    },
    setContractCallingFromObj() {
      // console.log(this.contractServiceId)
      this.showRate = false;
      this.$nextTick(() => {
        this.callingFromObj = {
          id: (this.contractRateTemplateDetails && this.contractRateTemplateDetails.id) || null,
          name: CONSTANT.CONTRACT_TEMPLATE,
          contractid: this.selectedEdit.id || this.contractidd,
          contractservicesid: this.contractServiceId,
          rateeffectivedatefrom: this.Fromdate || (this.contractRateTemplateDetails && this.contractRateTemplateDetails.rateeffectivedatefrom) || null,
          rateeffectivedateto: this.Todate || (this.contractRateTemplateDetails && this.contractRateTemplateDetails.rateeffectivedateto) || null,
          contractRateTemplateDetails: this.contractRateTemplateDetails,
          servicetype : this.servicetype
        }
        this.Fromdate = this.callingFromObj.rateeffectivedatefrom;
        this.Todate = this.callingFromObj.rateeffectivedateto;
        this.showRate = true;
        // console.log(this.callingFromObj)
      })

    },
    eventFromChild() {
      //this.$emit("goBackToCreateContract")
      this.createTables();
    }
  }
}
Validator.extend('verifyTodate', {
  getMessage: field => "Rate Effective To Date should be greater than Rate Effective From Date.",
  validate: value => {
    var todate = new Date($("#EffectiveTodate").val());
    var fromdate = new Date($("#EffectiveFromdate").val());
     if (fromdate >= todate) {
      return false;
    }else{
      return true;
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/shared/components/Template1/rates/rates.component.js